import { RuleDefinition } from '../ruleDefinition';

// a plain copy: the condition is kept as data, not as the query builder's classes
export function createEmptyCondition(): RuleDefinition {
	return JSON.parse(JSON.stringify(RuleDefinition.emptyGroup())) as RuleDefinition;
}
